import React from 'react'
import { useExportTLPPoint, useGetTLPPoint } from '../../api/point'
import { PointDetails } from '../shared/PointDetails'
import { Button, CircularProgress } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useSnackbar } from 'notistack'

export const TLPPoint = () => {
  const { enqueueSnackbar } = useSnackbar()

  const [searchParams] = useSearchParams()

  const exportApi = useExportTLPPoint()

  const handleExport = async () => {
    const idParams = searchParams.get('id')
    const res = await exportApi
      .mutateAsync({ customerId: idParams })
      .catch((e) => enqueueSnackbar('Failed to export data', { variant: 'error' }))
    const url = URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `Mobil TLP Point - ${idParams}`)
    document.body.appendChild(link)
    link.click()
    if (res?.status === 200) enqueueSnackbar(`Exported`, { variant: 'success' })
    return res
  }

  return (
    <PointDetails
      title='Mobil TLP Point'
      useGetPoint={useGetTLPPoint}
      backLink={'tlp-point'}
      accountSummary={[
        { label: 'Earned Points', id: 'totalEarnedPoints' },
        { label: 'Spent Points', id: 'totalSpentPoints' },
        {
          label: 'Export',
          id: 'export',
          view: () => {
            return (
              <Button
                variant='outlined'
                endIcon={exportApi.isLoading && <CircularProgress size='1.5rem' />}
                disabled={exportApi.isLoading}
                onClick={handleExport}
              >
                Export
              </Button>
            )
          },
        },
      ]}
      purchaseHistory={[
        { label: 'Liter', id: 'liter' },
        { label: 'Earned Points', id: 'earnedPoints' },
        { label: 'Spent Points', id: 'spentPoints' },
      ]}
    />
  )
}
